const Title = ({ children, mb = 6 }) => (
  <h4 className={`heading-xl sm:heading-3xl mb-3 sm:mb-${mb}`}>{children}</h4>
);

export default Title;
